<div id="standard-modal" role="dialog" aria-labelledby="modalContactList">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modalContactList">{{ 'shared.contactListModal.title' | translate }}</h4>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="close()"
        ></button>
      </div>

      <div class="modal-body custom-scroll-bar">
        <div class="row">
          <div class="col-12 input-trend-search">
            <input
              type="search"
              #searchBox
              class="form-control"
              [placeholder]="'shared.contactListModal.searchPlaceholder' | translate"
              (keyup)="search(searchBox.value)"
            />
            <span class="mdi mdi-magnify search-icon ml-2"></span>
          </div>
        </div>

        @if (loadingContent) {
          <content-loading-list />
        } 
        
        @if (pager.total == 0) {
          <empty-records-legacy-component
            [message]="'shared.contactListModal.emptyMessage' | translate"
            [subMessage]="'shared.contactListModal.emptySubMessage' | translate"
          />
        } 
        
        @if (pager.total > 0) {
          <div class="card-body table-responsive">
            <table class="table table-hover table-centered mb-0">
              <thead>
                <tr>
                  <th class="text-primary-emphasis">{{ 'shared.contactListModal.columnName' | translate }}</th>
                  <th class="text-primary-emphasis">{{ 'shared.contactListModal.columnEmail' | translate }}</th>
                  <th class="text-primary-emphasis">{{ 'shared.contactListModal.columnPhone' | translate }}</th>

                  @if (!!data && data?.channel) {
                    <th class="text-primary-emphasis">{{ 'shared.contactListModal.columnBlockUnblock' | translate }}</th>
                  }
                  <th><span class="sr-only"></span></th>
                </tr>
              </thead>
              <tbody>
                @for (item of pager.list; track $index) {
                <tr>
                  <td>
                    <span class="table-user-thumbnail d-flex align-items-center">
                      <img
                        class="me-2 rounded-circle imageSize"
                        [src]="getContactImage(item)"
                        [alt]="item.name"
                        (error)="onImageError($event)"
                        width="40"
                        height="40"
                      />
                      <strong class="text-truncate">{{ item.name }}</strong>
                    </span>
                  </td>
                  <td>{{ item.email ?? "-" | truncate : 50 }}</td>
                  <td>{{ item.phone }}</td>
                  @if (!!data && data?.channel) {
                  <td>
                    {{
                      (item?.blockedChannels?.includes(data.channel._id)
                        ? 'shared.contactListModal.unblock'
                        : 'shared.contactListModal.block') | translate
                    }}
                  </td>
                  }
                  <td>
                    <button
                      class="btn btn-sm btn-dark"
                      (click)="select(item)"
                    >
                      <i class="ri-check-line"></i>
                      {{ 'shared.contactListModal.selectButton' | translate }}
                    </button>
                  </td>
                </tr>
                }
              </tbody>
            </table>

            @if (pager.total > pager.perPage) {
              <paginator 
                [pager]="pager" 
                (onPager)="loadPage($event)" 
              />
            }
          </div>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="closeModal()">
          {{ 'shared.contactListModal.cancelButton' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
